import { ButtonBase, UndoAlt } from '@sparemin/blockhead';
import { fromJS } from 'immutable';
import React from 'react';

import { useTextOverlay } from 'blocks/TextOverlayModal/v2/state/TextOverlayProvider';

import { block } from '../../utils';
import { ResetPresetConfig } from './types';
import { getStyleResetOverlay } from './utils';

interface ResetPresetProps {
  aspectRatio: number;
  preset: ResetPresetConfig;
}

const ResetPreset: React.FunctionComponent<ResetPresetProps> = props => {
  const { aspectRatio, preset } = props;

  const { variant } = preset;
  const { onFullUpdate } = useTextOverlay();

  const handleClick = React.useCallback((): void => {
    const styleResetOverlay = getStyleResetOverlay(variant, aspectRatio);

    if (!styleResetOverlay) {
      return;
    }

    onFullUpdate(currOverlay =>
      currOverlay.withMutations(s => {
        s.setIn(
          ['editor', 'textStyle'],
          fromJS(styleResetOverlay.getIn(['editor', 'textStyle'])),
        )
          .set(
            'advancedTextConfigs',
            fromJS(styleResetOverlay.get('advancedTextConfigs')),
          )
          .set(
            'advancedAnimation',
            fromJS(styleResetOverlay.get('advancedAnimation')),
          );
        return s;
      }),
    );
  }, [aspectRatio, onFullUpdate, variant]);

  return (
    <ButtonBase
      className={block('preset-container', { transparent: true })}
      onPress={handleClick}
    >
      <UndoAlt fontSize={16} />
      Reset
    </ButtonBase>
  );
};

export default ResetPreset;
